import {useState} from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';

import LeadCard from './LeadCard';
import LeadDialog from './LeadDialog';
import LeadStatus from './LeadStatus';
import {formatLeadStatus} from '../../helpers/leads';
import {useGetLeadsQuery} from '../../redux/services/leadApi';
import config from '../../config/config';

const statuses = [
  'NEW',
  'CREATED_ACCOUNT',
  'COMPLETED_SIGNUP',
  'SCHEDULED',
];

const LeadKanban = ({leads, filters = {}, isAdmin = false}) => {
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const _statuses = [...statuses, 'LOST'];
  const LOST_COUNT = isAdmin ? 50 : 5;
  const MAX_COUNT = 100;
  const queries = {
    'NEW': useGetLeadsQuery({...filters, status: 'NEW', limit: MAX_COUNT}),
    'CREATED_ACCOUNT': useGetLeadsQuery({...filters, status: 'CREATED_ACCOUNT', limit: MAX_COUNT}),
    'COMPLETED_SIGNUP': useGetLeadsQuery({...filters, status: 'COMPLETED_SIGNUP', limit: MAX_COUNT}),
    'SCHEDULED': useGetLeadsQuery({...filters, status: 'SCHEDULED', limit: MAX_COUNT}),
    'LOST': useGetLeadsQuery({
      ...filters, 
      status: 'LOST', 
      limit: LOST_COUNT,
    }, {}),
  };
  return (
    <Box style={{height: '100%'}}>
      <LeadDialog
        leadId={selectedLeadId}
        dialogIsOpen={!!selectedLeadId}
        onClose={() => {
          setSelectedLeadId(null);
        }}
      />
      <Stack 
        direction='row' 
        spacing={2} 
        paddingTop={4} 
        paddingBottom={4} 
        style={{overflowX: 'auto', height: '100%'}}
      >
        {
          _statuses
            .map(s => (
              <Box 
                marginTop={4}
                padding={2}
                style={{
                  background: config().colors.background, 
                  borderRadius: '1em',
                  border: '1px solid #e1e1e1',
                  minHeight: '50vh',
                  minWidth: '300px',
                  width: '300px',
                }}
              >
                <Stack spacing={2}>
                  <Typography variant='h3' align='center'>
                    <Stack direction='row' gap={1} alignItems='center'>
                      <LeadStatus lead={{status: s}}/>
                      ({queries[s]?.data?.data?.length})
                    </Stack>
                  </Typography>
                  {
                    queries[s]?.data?.count > (s === 'LOST' ? LOST_COUNT : MAX_COUNT) &&
                    <Stack direction='row' justifyContent='center' alignItems='center' spacing={1}>
                      <WarningIcon color='secondary' />
                      <Typography variant='body2' color='secondary' align='center'>
                        Showing only first {s === 'LOST' ? LOST_COUNT : MAX_COUNT} leads.
                      </Typography>
                    </Stack>
                  }
                  {
                    queries[s].isLoading &&
                    <Stack direction='row' justifyContent='center' alignItems='center'>
                      <CircularProgress />
                    </Stack>
                  }
                  {
                    queries[s]?.data?.data.filter(l => l.status === s).length === 0 &&
                    <Typography variant='body2' color='text.secondary' align='center'>
                      No leads in this status
                    </Typography>
                  }
                  {queries[s]?.data?.data.map(l => (
                    <LeadCard key={l.id} lead={l} onOpenLeadById={(e, id) => setSelectedLeadId(id)} />
                  ))}
                </Stack>
              </Box>
          ))
        }
      </Stack>
    </Box>
  );
};

export default LeadKanban;